// Generated by scripts/beauty-audit/review-makeup.mjs.
export const MAKEUP_ARCHIVE = {
  "reviewDate": "2026-10-06",
  "methodVersion": "makeup-archive-description-v1",
  "archivedSkuCount": 155,
  "archivedGroupCount": 81,
  "brands": [
    {
      "domain": "kyliecosmetics.com",
      "brand": "Kylie Cosmetics",
      "archivedSkuCount": 20,
      "archivedGroupCount": 20
    },
    {
      "domain": "hudabeauty.com",
      "brand": "Huda Beauty",
      "archivedSkuCount": 13,
      "archivedGroupCount": 12
    },
    {
      "domain": "www.rhodeskin.com",
      "brand": "rhode",
      "archivedSkuCount": 63,
      "archivedGroupCount": 35
    },
    {
      "domain": "fentybeauty.com",
      "brand": "Fenty Beauty",
      "archivedSkuCount": 59,
      "archivedGroupCount": 14
    }
  ]
} as const
